import env from './env'

const configs = {
  test: {
    urlBase: process.env.BASE_URL,
    apiBase: process.env.BASE_URL+'/api',
  },
  prod: {
    urlBase: process.env.BASE_URL,
    apiBase: process.env.BASE_URL+'/api',
  },
}

export default configs[env]
